import AudiometryResultView from "./audiometry-result-view";
import { useAudiometryResultModel } from "../useAudiometryResultModel";
import { AudiometryAnswerApiService } from "app/services/Ananse/impl/AudiometryAnswerApiService";
import { QuestionApiServiceImpl } from "app/services";

type PageProps = {
  getQuizNameById: (quizId: number) => Promise<string>;
};

const AudiometryResultPage = ({getQuizNameById}: PageProps) => {
  const audiometry = new AudiometryAnswerApiService();
    const questionService = new QuestionApiServiceImpl();

  const model = useAudiometryResultModel({
    audiometriaAnswerService: audiometry,
    questionService
  });

  return <AudiometryResultView {...model} getQuizNameById={getQuizNameById} />;
};

export default AudiometryResultPage;
